<template>
  <v-card class="cursor-pointer">
    <v-img v-if="image" :src="image.url" width="200" height="200" contain 
      @click="previewImage"></v-img>
    <v-container v-if="video && video.url">
      <video v-if="video.url.includes('firebasestorage.googleapis.com')" width="200" height="200" :src="video.url"
        controls>
        {{ $t('GeneralTranslations.YourBrowserDoesNotSupportTheVideoTag') }}.
      </video>
      <youtube v-if="video.url.includes('youtube.com')" :video-id="getYoutubeVideoId()" width="200" height="200">
      </youtube>
      <video-embed v-if="video.url.includes('vimeo.com') || video.url.includes('dailymotion.com')" width="200"
        height="200" :src="video.url"></video-embed>
    </v-container>
    <ChatPreviewImage ref="previewImageDlg" />
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import ChatPreviewImage from '@/components/chat/ChatPreviewImage.vue'
const getYoutubeVideoId = require('get-youtube-id');

//Although the mobile side stores media in an array `media[]`, we still use only one media file per message.
export default {
  name: "ChatMedia",
  components: { ChatPreviewImage },
  props: {
    data: Object
  },
  data() {
    return {
    }
  },
  computed: {
    facility() {
      return this.$store.state.authModule.currentFacilityData
    },
    dateTimeFormat() {
      return `${this.facility.dateFormat} ${this.facility.timeFormat}`
    },
    images() {
      return `${this.data.familyMember.id}${this.user.id}`
    },
    ...mapGetters({
      user: "user"
    }),
    image() {
      return this.data?.medias.find(x => x.type === 'image')
    },
    video() {
      return this.data?.medias.find(x => x.type === 'video')
    }
  },
  methods: {
    getYoutubeVideoId() {
      return getYoutubeVideoId(this.video.url)
    },
    previewImage() {
      this.$refs.previewImageDlg.open(this.image.url);
    }
  }
}
</script>

<style scoped lang="scss"></style>
